import { FileInfo } from 'app/ui/components/multi-file-uploader/MultiFileUploader';

import { request } from '../config';
import { parseDocumentCollectionResponse, parseDocumentResponse } from './parsers';

const DOCUMENTS_URL = 'documents.json?return_properties=true';
const DOCUMENTS_DELETE_URL = 'documents';

export interface FileRequest {
  type: string;
  file: string;
  metadata?: {
    [key: string]: string;
  };
  objectId: string | null;
  objectType: string;
}

export function addDocument(document: FileRequest, raw = false): Promise<FileInfo> {
  return request(
    {
      url: DOCUMENTS_URL,
      method: 'POST',
      data: { document },
    },
    (data) =>
      // Added timeout because of s3 404 error when private url is invoked immediately
      new Promise((resolve) => {
        if (raw) {
          setTimeout(() => resolve(data.model), 100);
        } else {
          setTimeout(() => resolve(parseDocumentResponse(data.model)), 100);
        }
      })
  );
}

export function updateDocument(id: string, document: Partial<FileRequest>, raw = false): Promise<FileInfo> {
  return request(
    {
      url: `documents/${id}.json`,
      method: 'PATCH',
      data: { document },
    },
    (data) =>
      // Added timeout because of s3 404 error when private url is invoked immediately
      new Promise((resolve) => {
        if (raw) {
          setTimeout(() => resolve(data.model), 100);
        } else {
          setTimeout(() => resolve(parseDocumentResponse(data.model)), 100);
        }
      })
  );
}

export function deleteDocument(id: string): Promise<FileInfo> {
  return request(
    {
      url: `${DOCUMENTS_DELETE_URL}/${id}.json`,
      method: 'DELETE',
    },
    (data) =>
      new Promise((resolve) => {
        setTimeout(() => resolve(data.model.id), 10);
      })
  );
}

export function archiveDocument(id: string): Promise<FileInfo> {
  return request(
    {
      url: `${DOCUMENTS_DELETE_URL}/${id}/archive-or-delete.json`,
      method: 'PATCH',
    },
    (data) =>
      new Promise((resolve) => {
        setTimeout(() => resolve(data.model.id), 10);
      })
  );
}

export function getDocuments(equipmentId: string): Promise<FileInfo[]> {
  return request(
    {
      url: DOCUMENTS_URL,
      method: 'GET',
      params: { objectId: equipmentId },
    },
    (data) => {
      return parseDocumentCollectionResponse(data.models.results);
    }
  );
}
